import { COSUtil } from './COSUtil';
const { initCOS, putCOS, getEnctyptImgUrl } = COSUtil;
// 辅助管理html2canvas动态引入
let html2canvasLoadPromise = null;

function loadHtml2canvas() {
    if (html2canvasLoadPromise) return html2canvasLoadPromise;
    html2canvasLoadPromise = import(/* webpackChunkName: "html2canvas" */ './html2canvas.esm.js');
    return html2canvasLoadPromise;
}

function getShareScreenShot(element, quality) {
    if (element) {
        return getScreenShot(element, element.offsetWidth, element.offsetHeight, quality);
    } else {
        return getDefaultShareScreenShot();
    }
}

// 默认的分享图片 截取当前页面顶部截图 1:1尺寸
function getDefaultShareScreenShot() {
    console.info('getDefaultShareScreenShot 1');
    const width = document.body.offsetWidth;
    return getScreenShot(document.body, width, width);
}

async function getCanvas(target, width, height, quality) {
    console.info('getCanvas 1');
    const html2canvas = (await loadHtml2canvas()).default;
    let isDialog = false;
    if (target != document.body) {
        let node = target;
        while (node) {
            if (node.id === 'dialog-root') {
                isDialog = true;
                break;
            } else {
                node = node.parentNode;
            }
        }
    }

    console.info('getCanvas 2');
    const data = await html2canvas(target, {
        scale: quality ? quality : 1, // 图片清晰度
        useCORS: true,
        width,
        height,
        ignoreElements: (element) => {
            // eslint-disable-next-line sonarjs/prefer-single-boolean-return
            if (!isDialog && element.id == 'dialog-root') {
                return true;
            }
            return false;
        },
    });
    console.info('getCanvas 3');
    return data;
}

async function getScreenShot(target, width, height, quality) {
    console.info('getScreenShot 1');
    const canvas = await getCanvas(target, width, height, quality);
    console.info('getScreenShot 2');
    return canvas.toDataURL('image/jpeg');
}

async function uploadScreenShot(target, savePath) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
        try {
            const promises = [
                initCOS(),
                getCanvas(target, target.offsetWidth, target.offsetHeight, 10),
            ];

            const [cos, canvas] = await Promise.all(promises);
            if (!cos) throw new Error('初始化COS失败');

            canvas.toBlob(
                async (blob) => {
                    try {
                        if (!blob) {
                            console.error('uploadScreenShot canvas.toBlob blob为空');
                            reject(new Error('截图生成失败'));
                        } else {
                            const key = `common-activity/shot/${savePath}/${new Date().getTime()}-${Math.ceil(
                                Math.random() * 10000
                            )}.jpg`;
                            const result = await putCOS(cos, blob, key);
                            const { statusCode } = result;
                            if (statusCode === 200) {
                                const { code, data, message } = await getEnctyptImgUrl(key);
                                if (code === 200) {
                                    const { img_url } = data;
                                    resolve(img_url);
                                } else {
                                    reject(new Error(message));
                                }
                            } else {
                                reject(new Error('图片上传失败#1'));
                            }
                        }
                    } catch (error) {
                        console.error(
                            'uploadScreenShot canvas.toBlob callback',
                            error.message,
                            error
                        );
                        reject(error);
                    }
                },
                'image/jpeg',
                0.7
            );
        } catch (error) {
            reject(error);
        }
    });
}

export const screenShot = {
    loadHtml2canvas,
    getScreenShot,
    getDefaultShareScreenShot,
    getShareScreenShot,
    uploadScreenShot,
};
